import {
    GET_HIREMEMO_REQUEST, GET_HIREMEMO_SUCCESS, GET_HIREMEMO_FAIL,
    GET_HIREMEMOPDF_REQUEST, GET_HIREMEMOPDF_SUCCESS, GET_HIREMEMOPDF_FAIL,
    DELETE_HIREMEMO_REQUEST, DELETE_HIREMEMO_SUCCESS, DELETE_HIREMEMO_FAIL,
    EXPORT_HIREMEMO_REQUEST, EXPORT_HIREMEMO_SUCCESS, EXPORT_HIREMEMO_FAIL
} from "../types/hireMemoTypes";

function deleteHireMemoReducer(state = { deleteHireMemo: {} }, action) {
    switch (action.type) {
        case DELETE_HIREMEMO_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_HIREMEMO_SUCCESS:
            return {
                ...state,
                deleteHireMemo: action.payload,
                isLoading: false
            }
        case DELETE_HIREMEMO_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function getHireMemoReducer(state = { hireMemo: [] }, action) {
    switch (action.type) {
        case GET_HIREMEMO_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_HIREMEMO_SUCCESS:
            return {
                ...state,
                hireMemo: action.payload,
                isLoading: false
            }
        case GET_HIREMEMO_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function generateHireMemoReducer(state = { hireMemoPDF: [] }, action) {
    switch (action.type) {
        case GET_HIREMEMOPDF_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_HIREMEMOPDF_SUCCESS:
            return {
                ...state,
                hireMemoPDF: action.payload,
                isLoading: false
            }
        case GET_HIREMEMOPDF_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function exportHireMemoReducer(state = { hireMemo: [] }, action) {
    switch (action.type) {
        case EXPORT_HIREMEMO_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case EXPORT_HIREMEMO_SUCCESS:
            return {
                ...state,
                hireMemo: action.payload,
                isLoading: false
            }
        case EXPORT_HIREMEMO_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}



export { getHireMemoReducer, generateHireMemoReducer, deleteHireMemoReducer, exportHireMemoReducer }